var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var unknownCaller = '[aws-rum-web:unknown.unknown]';
var InternalLogger = /** @class */ (function () {
    function InternalLogger() {
    }
    InternalLogger.getCallerInfo = function () {
        var _a, _b;
        try {
            var stack = new Error().stack;
            if (!stack) {
                return unknownCaller;
            }
            var lines = stack.split('\n');
            if (lines.length < 4) {
                return unknownCaller;
            }
            // Skip Error, getCallerInfo, and the logger method itself
            var callerLine = lines[3];
            if (!callerLine) {
                return unknownCaller;
            }
            // Extract class and method name from stack trace
            var match = callerLine.match(/at (?:(.+?)\s+\()?/);
            if (match && match.length >= 2) {
                var fullName = match[1].trim();
                // Extract class.method format
                var parts = fullName.split('.');
                if (parts.length >= 2) {
                    var className = (_a = parts[parts.length - 2]) !== null && _a !== void 0 ? _a : 'unknown';
                    var methodName = (_b = parts[parts.length - 1]) !== null && _b !== void 0 ? _b : 'unknown';
                    return "[aws-rum-web:".concat(className, ".").concat(methodName, "]");
                }
                return "[aws-rum-web:".concat(fullName, "]");
            }
        }
        catch (_) {
            // do nothing
        }
        return unknownCaller;
    };
    InternalLogger.info = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        var prefix = this.getCallerInfo();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        console.info.apply(console, __spreadArray([prefix, message], optionalParams, false));
    };
    InternalLogger.debug = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        var prefix = this.getCallerInfo();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        console.debug.apply(console, __spreadArray([prefix, message], optionalParams, false));
    };
    InternalLogger.warn = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        var prefix = this.getCallerInfo();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        console.warn.apply(console, __spreadArray([prefix, message], optionalParams, false));
    };
    InternalLogger.error = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        var prefix = this.getCallerInfo();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        console.error.apply(console, __spreadArray([prefix, message], optionalParams, false));
    };
    return InternalLogger;
}());
export { InternalLogger };
